import type { BomItem, Supplier, SupplyChainPlan } from '../types/supplyChain';

/** Pick a BoM line for supplier outreach when none is scoped. */
export function defaultBomItemForSupplier(
  plan: SupplyChainPlan | undefined,
  supplier: Supplier,
): BomItem | null {
  if (!plan?.bom.length) return null;
  const shortlisted = plan.bom.find(b =>
    (b.shortlistedSupplierIds ?? []).includes(supplier.id),
  );
  if (shortlisted) return shortlisted;
  const categoryMatch = plan.bom.find(b =>
    supplier.categories.includes(b.category),
  );
  return categoryMatch ?? plan.bom[0] ?? null;
}

export function supplierOutreachProjectFromSite(site: {
  id: string;
  name: string;
  address: string;
  financialAssumptions?: { inServiceDate?: string | null }; // SSOT-SENTINEL-OK site COD fallback, not Preferences
  projectIntent?: { inServiceDate?: string | null; technologyLabel?: string | null }; // SSOT-SENTINEL-OK canonical + tech label
}): import('../services/supplyChain/buildSupplierOutreachEmail').SupplierOutreachContext {
  return {
    siteId: site.id,
    siteName: site.name,
    siteAddress: site.address,
    cod: site.financialAssumptions?.inServiceDate ?? site.projectIntent?.inServiceDate ?? null,
    technologyLabel: site.projectIntent?.technologyLabel ?? null,
    issuingCompany: 'Datacrate',
  };
}
